var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "histo", staticStyle: { height: "100%" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "", height: _vm.chatHeight } },
        [
          _vm.navigation
            ? _c(
                "v-navigation-drawer",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listChats,
                      expression: "listChats"
                    }
                  ],
                  staticClass: "contentListeHistoChats",
                  attrs: {
                    "enable-resize-watcher": "",
                    width: "320",
                    light: "",
                    absolute: "",
                    persistent: "",
                    clipped: "",
                    "hide-overlay": ""
                  },
                  model: {
                    value: _vm.listChats,
                    callback: function($$v) {
                      _vm.listChats = $$v
                    },
                    expression: "listChats"
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "white",
                      attrs: { flat: "", dense: "", extended: "" }
                    },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("conversationHistory")))
                      ]),
                      _vm._v(" "),
                      _vm.visiteurs.length
                        ? _c(
                            "div",
                            {
                              staticStyle: { display: "-webkit-box" },
                              attrs: { slot: "extension" },
                              slot: "extension"
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { padding: "13px 2px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tc(
                                        "visitors",
                                        _vm.visiteurs.length,
                                        { count: _vm.visiteurs.length }
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "subheading",
                              attrs: { slot: "extension" },
                              slot: "extension"
                            },
                            [_vm._v(_vm._s(_vm._f("cap")(_vm.$tc("chats", 0))))]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "listeChatsVisiteurs" },
                    [
                      _vm.loadingHisto
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-list",
                            { attrs: { "two-line": "", dense: "" } },
                            _vm._l(_vm.chatsSorted, function(visiteur) {
                              return _c(
                                "v-list-group",
                                {
                                  key: visiteur.visId,
                                  attrs: {
                                    value: visiteur.visId == _vm.visitorSelected
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator", ripple: "" },
                                      on: { click: function($event) {} },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c("wz-avatar", {
                                            attrs: {
                                              username: "#" + visiteur.visId,
                                              size: "35px"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(_vm._s(visiteur.visId))
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$tc(
                                                  "chats",
                                                  visiteur.chats.length,
                                                  {
                                                    count: visiteur.chats.length
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(visiteur.chats, function(chat) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: chat.id,
                                        class: {
                                          "grey lighten-2":
                                            chat.id == _vm.chatId
                                        },
                                        attrs: { ripple: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showChat(chat.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("wz-avatar-double", {
                                          attrs: {
                                            avatars: [
                                              { id: visiteur.visId },
                                              {
                                                id: chat.last.agentId,
                                                username: chat.last.agentName
                                              }
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", [
                                              _vm._v(
                                                _vm._s(
                                                  chat.last.auteur == "Visiteur"
                                                    ? visiteur.visId
                                                    : chat.last.agentName
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("v-list-tile-sub-title", [
                                              _vm._v(_vm._s(chat.last.text))
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-action", [
                                          _vm._v(_vm._s(chat.last.date))
                                        ])
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            }),
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c("v-pagination", {
                                    attrs: {
                                      length: _vm.calculTotalpagination,
                                      circle: "",
                                      disabled: _vm.numChatsTotal <= 100
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.paginationInput(
                                          _vm.pagination
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.pagination,
                                      callback: function($$v) {
                                        _vm.pagination = $$v
                                      },
                                      expression: "pagination"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.toolbar
            ? _c(
                "v-toolbar",
                {
                  staticClass: "primary",
                  class: { "histo__navigation--opened": _vm.listChats },
                  attrs: { dark: "", dense: "", extended: "" }
                },
                [
                  _vm.navigation
                    ? _c("v-toolbar-side-icon", {
                        nativeOn: {
                          click: function($event) {
                            _vm.listChats = !_vm.listChats
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chatId
                    ? _c("v-toolbar-title", { staticClass: "white--text" }, [
                        _vm._v("#" + _vm._s(_vm.visitorSelected))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chatSelected && _vm.$route.name != "leads"
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "icon",
                            loading: _vm.loadingExportChat,
                            disabled: _vm.loadingExportChat
                          },
                          on: {
                            click: function($event) {
                              return _vm.showLead(_vm.visitorSelected)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("info_outline")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chatSelected
                    ? _c(
                        "div",
                        {
                          staticClass: "white--text subheading",
                          attrs: { slot: "extension" },
                          slot: "extension"
                        },
                        [
                          false
                            ? _c("v-tooltip", { attrs: { right: "" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "mr-3",
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { dark: "" } }, [
                                      _vm._v("access_time")
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.chatSelected.duration) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Durée totale")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          false
                            ? _c("v-tooltip", { attrs: { right: "" } }, [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { dark: "" } }, [
                                      _vm._v("timer")
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.chatSelected.averageResponse
                                        ) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chatsAverageResponse")))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ml-2" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.chatSelected.messages.length) +
                                  "\n            "
                              ),
                              _c("v-icon", { attrs: { dark: "", right: "" } }, [
                                _vm._v("chat_bubble_outline")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.chatSelected.closed
                            ? _c(
                                "span",
                                { staticClass: "ml-2" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("closing")) +
                                      " : " +
                                      _vm._s(_vm.chatSelected.closed) +
                                      "\n            "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { dark: "", right: "" } },
                                    [_vm._v("offline_pin")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.chatSelected
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "icon",
                            loading: _vm.loadingExportChat,
                            disabled: _vm.loadingExportChat
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportChat()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("file_download")])],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "main",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              ref: "contentChat",
              class: {
                "histo__navigation--opened vb": _vm.listChats,
                "histo__main--toolbar vb": _vm.toolbar,
                "histo__main--no-toolbar vb": !_vm.toolbar
              },
              staticStyle: { height: "100%" },
              attrs: { id: "contentChat" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "histo__main--scroll",
                  attrs: { "grid-list-sm": "", fluid: "" }
                },
                [
                  _vm.loading
                    ? _c(
                        "v-card",
                        { attrs: { height: _vm.chatHeight } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-5" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.chatSelected
                    ? _c(
                        "div",
                        { attrs: { height: "100%", width: "100%" } },
                        [
                          _c(
                            "transition",
                            {
                              attrs: {
                                name: "slide-x-reverse-transition",
                                mode: "out-in"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _vm._l(_vm.chatSelected.messages, function(
                                    msg,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        class: [
                                          msg.anotherDay
                                            ? "chatDate"
                                            : "chatLigne"
                                        ]
                                      },
                                      [
                                        msg.anotherDay
                                          ? _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-center sticky",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dateMessageChat",
                                                    attrs: { secondary: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(msg.anotherDay)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            msg.auteur == "Agent" &&
                                            (msg.text != "" ||
                                              msg.attachment != "")
                                              ? _c(
                                                  "v-layout",
                                                  { attrs: { row: "" } },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        staticClass:
                                                          "text-xs-right",
                                                        attrs: { xs2: "" }
                                                      },
                                                      [
                                                        _c("wz-avatar", {
                                                          attrs: {
                                                            username:
                                                              msg.agentName,
                                                            src:
                                                              _vm.domaine +
                                                              "/public/media/user/small/" +
                                                              msg.agentId +
                                                              "_avatar.jpg",
                                                            size: "35px"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs10: "" } },
                                                      [
                                                        _c(
                                                          "v-card",
                                                          {
                                                            class: [
                                                              "histo__bubble",
                                                              "histo__bubble--agent",
                                                              _vm.colorChatAgent
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "v-card-text",
                                                              {
                                                                staticClass:
                                                                  "pa-1"
                                                              },
                                                              [
                                                                msg.text &&
                                                                msg.text != ""
                                                                  ? _c("div", {
                                                                      staticClass:
                                                                        "contentChatMessageTxt",
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.md.render(
                                                                            msg.text
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  : msg.attachment &&
                                                                    msg.attachment !=
                                                                      ""
                                                                  ? _c("img", {
                                                                      attrs: {
                                                                        src:
                                                                          _vm.awss3Public +
                                                                          "/" +
                                                                          msg.attachment,
                                                                        alt:
                                                                          "Image indisponible"
                                                                      }
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c("small", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      msg.type ==
                                                                        "2"
                                                                        ? " (auto)"
                                                                        : ""
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                msg.hasCarrousel
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        class: [
                                                                          "white--text",
                                                                          "primary"
                                                                        ],
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.loadCarrousel(
                                                                              msg.index
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                Charger Carrousel\n                                "
                                                                        ),
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              right:
                                                                                "",
                                                                              dark:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "search"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm
                                                                  .carrouselReady
                                                                  .length > 0 &&
                                                                msg.date ==
                                                                  _vm
                                                                    .carrouselReady[
                                                                    msg.index
                                                                  ]
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tf-carousel-chat",
                                                                        attrs: {
                                                                          id:
                                                                            "tf_carrousel_" +
                                                                            msg.index
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-carousel",
                                                                          {
                                                                            attrs: {
                                                                              max:
                                                                                "200",
                                                                              height:
                                                                                "400",
                                                                              dark:
                                                                                ""
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm
                                                                              .bullesChatSelected[
                                                                              msg
                                                                                .index
                                                                            ],
                                                                            function(
                                                                              card,
                                                                              index
                                                                            ) {
                                                                              return _c(
                                                                                "v-carousel-item",
                                                                                {
                                                                                  key: index,
                                                                                  attrs: {
                                                                                    src:
                                                                                      card.image
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-card",
                                                                                    [
                                                                                      _c(
                                                                                        "v-card-title",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              card.title
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "v-card-text",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              card.description
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                msg.loading ==
                                                                "loading"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "loading-carousel-chat elevation-2"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-progress-circular",
                                                                          {
                                                                            attrs: {
                                                                              size: 50,
                                                                              color:
                                                                                "primary",
                                                                              indeterminate:
                                                                                ""
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                                Chargement en cours\n                              "
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "small",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    msg.agentName
                                                                  ) +
                                                                    " • " +
                                                                    _vm._s(
                                                                      msg.date
                                                                    ) +
                                                                    " "
                                                                ),
                                                                msg.messaging ==
                                                                1
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "messagingBubble secondary--text text--lighten-1",
                                                                        attrs: {
                                                                          size:
                                                                            "20",
                                                                          title: _vm.$t(
                                                                            "offlineMessaging"
                                                                          )
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "chat_bubble"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              msg.params,
                                                              function(
                                                                param,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: index
                                                                  },
                                                                  [
                                                                    index ===
                                                                      "contextAI" &&
                                                                    param != ""
                                                                      ? _c(
                                                                          "small",
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                attrs: {
                                                                                  flat:
                                                                                    "",
                                                                                  icon:
                                                                                    "",
                                                                                  color:
                                                                                    "blue lighten-2"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      title:
                                                                                        "Context AI : " +
                                                                                        param
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.openSource(
                                                                                          param
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "psychology_alt"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    index ===
                                                                      "source" &&
                                                                    param.length
                                                                      ? _c(
                                                                          "small",
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                attrs: {
                                                                                  flat:
                                                                                    "",
                                                                                  icon:
                                                                                    "",
                                                                                  color:
                                                                                    "blue lighten-2"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      title:
                                                                                        "Source AI : " +
                                                                                        param
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.openSource(
                                                                                          param
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "description"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-flex", {
                                                      staticClass:
                                                        "hidden-sm-and-down",
                                                      attrs: { md3: "" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : msg.auteur == "Visiteur" &&
                                                (msg.text != "" ||
                                                  msg.attachment != "")
                                              ? _c(
                                                  "v-layout",
                                                  { attrs: { row: "" } },
                                                  [
                                                    _c("v-flex", {
                                                      staticClass:
                                                        "hidden-sm-and-down",
                                                      attrs: { md3: "" }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        staticClass:
                                                          "text-xs-right",
                                                        attrs: {
                                                          xs10: "",
                                                          md8: ""
                                                        }
                                                      },
                                                      [
                                                        msg.type == "1"
                                                          ? _c(
                                                              "v-card",
                                                              {
                                                                class: [
                                                                  "white--text",
                                                                  "histo__bubble",
                                                                  "histo__bubble--visitor",
                                                                  _vm.colorChatVisiteur
                                                                ]
                                                              },
                                                              [
                                                                _c(
                                                                  "v-card-text",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-right pa-1"
                                                                  },
                                                                  [
                                                                    msg.text &&
                                                                    msg.text !=
                                                                      ""
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "pr-2 contentChatMessageTxt",
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                msg.text
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      : msg.attachment &&
                                                                        msg.attachment !=
                                                                          ""
                                                                      ? _c(
                                                                          "img",
                                                                          {
                                                                            attrs: {
                                                                              src:
                                                                                _vm.awss3Public +
                                                                                "/" +
                                                                                msg.attachment,
                                                                              alt:
                                                                                "Image indisponible"
                                                                            }
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "v-card",
                                                              {
                                                                class: [
                                                                  "white--text",
                                                                  "histo__CTA",
                                                                  _vm.colorCta
                                                                ]
                                                              },
                                                              [
                                                                _c(
                                                                  "v-card-text",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-right pa-1"
                                                                  },
                                                                  [
                                                                    msg.text &&
                                                                    msg.text !=
                                                                      ""
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "pr-2 contentChatMessageTxt",
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                msg.text
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          [
                                                            _vm._v(
                                                              _vm._s(msg.date) +
                                                                " "
                                                            ),
                                                            msg.messaging == 1
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "messagingBubble secondary--text text--lighten-1",
                                                                    attrs: {
                                                                      size:
                                                                        "20",
                                                                      title: _vm.$t(
                                                                        "offlineMessaging"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "chat_bubble"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs2: "" } },
                                                      [
                                                        _c("wz-avatar", {
                                                          attrs: {
                                                            username:
                                                              "#" +
                                                              _vm.visitorSelected,
                                                            size: "35px"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.chatSelected.closed
                                    ? _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    label: "",
                                                    disabled: "",
                                                    color: "secondary",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("closing")
                                                      ) +
                                                      " : " +
                                                      _vm._s(
                                                        _vm.chatSelected.closed
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        dark: ""
                                                      }
                                                    },
                                                    [_vm._v("offline_pin")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-alert",
                        {
                          attrs: {
                            color: "blue",
                            icon: "info",
                            value: "true",
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$tc("chats", 0))) +
                              "\n          "
                          )
                        ]
                      )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.dialogEdit,
            callback: function($$v) {
              _vm.dialogEdit = $$v
            },
            expression: "dialogEdit"
          }
        },
        [
          _c("wz-editeur-lead", {
            attrs: {
              leadDialog: _vm.leadDialog,
              custom_motifs: _vm.custom_motifs,
              custom_champs: _vm.custom_champs,
              showHisto: false,
              histoChat: true
            },
            on: {
              closeDialog: _vm.dialogEditeurRemove,
              updateLead: _vm.updateLeadSubmit
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63675642", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63675642","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHistoChats.vue
// module id = null
// module chunks = 